import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { UnitTypes } from "constant";
import { ModalTypes } from "components/modals/interfaces";
import features from "features";

const useDeleteMarker = () => {
  const { id: projectId } = useParams();
  const dispatch = useDispatch();

  const onDeleteMarker = useCallback(
    (markerId, alias, onSuccess?) => () => {
      dispatch(
        features.modal.actions.showModal({
          modalType: ModalTypes.DELETE,
          modalProps: {
            title: "Delete Marker?",
            subtitle:
              "Are you sure you want to delete this marker from the map? This action cannot be undone.",
            onAcceptClick: () =>
              dispatch(
                features.unitsManager.actions.deleteUnitRequest({
                  params: {
                    projectId,
                    unitId: markerId,
                    type: UnitTypes.POINT,
                    alias
                  },
                  onSuccess: () => {
                    if (onSuccess) onSuccess();
                    dispatch(features.modal.actions.hideModal());
                  }
                })
              )
          }
        })
      );
    },
    [dispatch, projectId]
  );

  return onDeleteMarker;
};
export default useDeleteMarker;
